/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_approvePendingSelectionsRequest } from '../models/api_approvePendingSelectionsRequest';
import type { api_createAllocationRequest } from '../models/api_createAllocationRequest';
import type { api_createAllocationResponse } from '../models/api_createAllocationResponse';
import type { api_getAllocationResponse } from '../models/api_getAllocationResponse';
import type { api_standardizeAllocationScoresRequest } from '../models/api_standardizeAllocationScoresRequest';
import type { db_GetBudgetStatisticsRow } from '../models/db_GetBudgetStatisticsRow';
import type { db_ListAllocationPendingOffersRow } from '../models/db_ListAllocationPendingOffersRow';
import type { db_ListAllocationsRow } from '../models/db_ListAllocationsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Allocations {
    /**
     * Get a list of allocations (admin)
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListAllocationsRow OK
     * @throws ApiError
     */
    public static listAllocations(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListAllocationsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allocations',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an allocation
     * @param body Allocation details
     * @returns api_createAllocationResponse Created
     * @throws ApiError
     */
    public static createAllocation(
        body: api_createAllocationRequest,
    ): CancelablePromise<api_createAllocationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allocations',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an allocation record
     * @param id Allocation ID
     * @returns api_getAllocationResponse OK
     * @throws ApiError
     */
    public static getAllocation(
        id: number,
    ): CancelablePromise<api_getAllocationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allocations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an allocation record
     * @param id Allocation ID
     * @param body Allocation details
     * @returns void
     * @throws ApiError
     */
    public static updateAllocation(
        id: number,
        body: api_createAllocationRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/allocations/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete an allocation
     * @param id Allocation ID
     * @returns void
     * @throws ApiError
     */
    public static deleteAllocation(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/allocations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Approve pending selections for an allocation
     * @param id Allocation ID
     * @param body Beneficiary IDs to approve
     * @returns void
     * @throws ApiError
     */
    public static approvePendingSelections(
        id: number,
        body: api_approvePendingSelectionsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allocations/{id}/approve-pending-selections',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Confirm conditional offers for an allocation
     * @param id Allocation ID
     * @param awardId Award ID
     * @returns void
     * @throws ApiError
     */
    public static confirmConditionalOffers(
        id: number,
        awardId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allocations/{id}/award/{award_id}/confirm-conditional-offers',
            path: {
                'id': id,
                'award_id': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Verify if conditional offers can be confirmed
     * @param id Allocation ID
     * @param awardId Award ID
     * @returns db_ListAllocationPendingOffersRow OK
     * @throws ApiError
     */
    public static listAllocationPendingOffers(
        id: number,
        awardId: number,
    ): CancelablePromise<Array<db_ListAllocationPendingOffersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allocations/{id}/award/{award_id}/pending-conditional-offers',
            path: {
                'id': id,
                'award_id': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get allocation budget statistics
     * @param id Allocation ID
     * @returns db_GetBudgetStatisticsRow OK
     * @throws ApiError
     */
    public static getAllocationBudgetStatistics(
        id: number,
    ): CancelablePromise<db_GetBudgetStatisticsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allocations/{id}/budget-statistics',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Standardize committee scores
     * @param id Allocation ID
     * @param body Award ID
     * @returns void
     * @throws ApiError
     */
    public static standardizeAllocationScores(
        id: number,
        body: api_standardizeAllocationScoresRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allocations/{id}/standardize-scores',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
}
